import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ProgressService } from '@services/progress.service';
import { SvgIconComponent } from 'angular-svg-icon';

export type ProgressMessage = {
    message: string;
    id: string;
};

@Component({
    selector: 'pn-progress',
    standalone: true,
    imports: [CommonModule, SvgIconComponent],
    templateUrl: './progress.component.html',
    styleUrl: './progress.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('showProgress', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(
                    '225ms cubic-bezier(0.35, 0, 0.25, 1)',
                    style({ transform: 'none', opacity: '*' })
                ),
            ]),
            transition(':leave', [animate('225ms', style({ transform: 'translateX(150%)' }))]),
        ]),
    ],
})
export class ProgressComponent implements OnInit {
    public progress: Array<string | ProgressMessage> = [];

    constructor(
        private readonly _progressService: ProgressService,
        private readonly _cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this._progressService.progress.subscribe((message) => {
            if ((typeof message === 'object' && !message.message.trim()) || !message) {
                return;
            }

            this.progress.push(message);
            this._cd.detectChanges();
        });

        this._progressService.clearProgress.subscribe((message) => {
            if (message) {
                const index = this.progress.findIndex((m) => {
                    if (typeof m === 'string') {
                        return m === message;
                    }
                    return m.id === message;
                });
                this.progress.splice(index, 1);
            } else {
                this.progress = [];
            }
            this._cd.detectChanges();
        });
    }

    /**
     * Get message
     *
     * @param {(string | ProgressMessage)} message
     * @return {*}  {string}
     * @memberof ProgressComponent
     */
    public getMessage(message: string | ProgressMessage): string {
        if (typeof message === 'string') {
            return message;
        }
        return message.message;
    }
}
